module.exports = __webpack_public_path__ + "img/backup.3213da4.svg";